import { render, staticRenderFns } from "./LandingSectionImage.vue?vue&type=template&id=249a297a&scoped=true&"
import script from "./LandingSectionImage.vue?vue&type=script&lang=js&"
export * from "./LandingSectionImage.vue?vue&type=script&lang=js&"
import style0 from "./LandingSectionImage.vue?vue&type=style&index=0&id=249a297a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a297a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingText: require('/home/circleci/repo/components/landing/elements/LandingText.vue').default,LandingButton: require('/home/circleci/repo/components/landing/elements/LandingButton.vue').default,LandingImage: require('/home/circleci/repo/components/landing/elements/LandingImage.vue').default})
